export default "__VITE_ASSET__DipT_VBo__"